import IconFactory from "@components/Icon/IconFactory";
import { IconTypeEnum } from "@components/Icon/utils/types";
import DownloadReport from "@routes/Keyword/templates/AseanInsights/components/DownloadReport";
import { DOWNLOAD_BUTTON_ATTRIBUTES } from "@routes/Keyword/templates/AseanInsights/utils/constants";
import { cn } from "@util/helpers";

type AttachmentProps = {
  /** This is the classname of the component. */
  className?: string;
  /** The URL of the attachment do be viewed/downloaded. */
  attachmentURL: string;
};

/**
 * The attachment block to display the attachment url with icon.
 * @figma https://www.figma.com/design/9RrH1KYIUOZk6rvgzlBBKX/WEB-BAU-2026?node-id=20436-71389&m=dev
 */
const Attachment = ({
  className,
  attachmentURL,
}: AttachmentProps): React.ReactElement => {
  return (
    <div
      data-testid="attachment-component"
      className={cn(
        "group relative flex cursor-pointer flex-col items-center justify-center border border-blue-100 bg-gray-75 p-12 lg:py-4",
        className
      )}
    >
      <IconFactory
        type={IconTypeEnum.graphic}
        className="mb-4 text-blue-175"
        x={64}
        y={64}
        size={64}
      />

      <h3 className="mb-6 text-center font-lct text-lg font-normal">
        Get our 2026 Asean Intelligence report
      </h3>

      <DownloadReport
        attributes={DOWNLOAD_BUTTON_ATTRIBUTES.widget}
        attachmentURL={attachmentURL}
      />
    </div>
  );
};

export default Attachment;
